"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOloRestaurantBodyToJSON = exports.CreateOloRestaurantBodyFromJSONTyped = exports.CreateOloRestaurantBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function CreateOloRestaurantBodyFromJSON(json) {
    return CreateOloRestaurantBodyFromJSONTyped(json, false);
}
exports.CreateOloRestaurantBodyFromJSON = CreateOloRestaurantBodyFromJSON;
function CreateOloRestaurantBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'oloRestaurantId': json['oloRestaurantId'],
        'merchantId': json['merchantId'],
        'parent': !(0, runtime_1.exists)(json, 'parent') ? undefined : json['parent'],
    };
}
exports.CreateOloRestaurantBodyFromJSONTyped = CreateOloRestaurantBodyFromJSONTyped;
function CreateOloRestaurantBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'oloRestaurantId': value.oloRestaurantId,
        'merchantId': value.merchantId,
        'parent': value.parent,
    };
}
exports.CreateOloRestaurantBodyToJSON = CreateOloRestaurantBodyToJSON;
